// extracted by mini-css-extract-plugin
module.exports = {"info":"info___3BBJs","container":"container___ytRqP","JFTalkBox":"JFTalkBox___3q4lt"};